import { useMutation } from '@tanstack/react-query';

import { authApi, type ResetPasswordRequest } from '@/api/routes/public/auth.api';
import { translateFile } from '@/i18n';

export const useResetPassword = () => {
  return useMutation({
    mutationFn: (data: ResetPasswordRequest) => authApi.resetPassword(data),
    meta: {
      showUserMessage: false,
      defaultUserMessage: translateFile('api.hooks.public.useResetPassword', 'error'),
    },
  });
};
